import React from "react";
import { Box } from "@material-ui/core";
import RAGIndicatorNew from "components/visuals/RAGIndicatorNew";

import { useAppSelector } from "store";
import { selectRankedForecastGrowthClassification } from "modules/customer/insights/portfolioNew/revenue/revenueSlice";

const RankedForecastGrowthClassification = () => {
    const rankedGrowthClassification = useAppSelector(selectRankedForecastGrowthClassification);
    return (
        <Box>
            <RAGIndicatorNew ragIndicator={rankedGrowthClassification} />
        </Box>
    );
};

export default RankedForecastGrowthClassification;
